﻿import $ from "jquery";
import { showMessage } from "./main";

$(() => {
    var currentPage = $("#currentPage").val();
    if (currentPage != "contactIndex") return;

    type ApiResult = {
        ok: boolean;
        message: string;
        errors?: Record<string, string[]>;
    };

    $("#btnSendContact").on("click", (e) => {
        e.preventDefault();

        const $form = $(".zuba-contact-form");

        const turnstileToken =
            String($form.find('input[name="cf-turnstile-response"]').val() ?? "").trim();

        const payload = {
            fullName: String($("#FullName").val() ?? "").trim(),
            email: String($("#Email").val() ?? "").trim(),
            serviceId: String($("#ServiceId").val() ?? "").trim(),
            message: String($("#Message").val() ?? "").trim(),

            // anti-bot
            website: String($form.find('input[name="website"]').val() ?? ""), // honeypot (nemusí byť trim)
            ts: Number(String($form.find('input[name="ts"]').val() ?? "").trim() || "0"),
            turnstileToken: turnstileToken
        };

        // (voliteľné) rýchla klientská kontrola
        if (!payload.fullName || !payload.email || !payload.serviceId || !payload.message) {
            showMessage("Vyplň prosím všetky polia.");
            return;
        }

        // Turnstile token musí byť prítomný
        if (!payload.turnstileToken) {
            showMessage("Prosím potvrďte, že nie ste robot, a skúste znova.", "Overenie");
            return;
        }

        try {
            const request = $.ajax({
                url: "/contact/send",
                method: "POST",
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(payload),
                beforeSend: function () {
                    $('#spinnerContainer').removeClass('d-none');
                },
                complete: function () {
                    $('#spinnerContainer').addClass('d-none');
                }
            });


            request.done(function (res) {
                if (res.error == true) {
                    showMessage(res.message, "Chyba!");
                }
                else {
                    showMessage(res.message);
                }

                // reset Turnstile, aby sa dalo odoslať znova bez refreshu
                // (existuje len keď je načítaný turnstile script)
                const w: any = window as any;
                if (w.turnstile && typeof w.turnstile.reset === "function") {
                    w.turnstile.reset();
                }
            });
            request.fail(function (jqXHR) {
                console.error(jqXHR)
            });
            
            // napr. vyčistiť formulár:
            // $("#contactForm")[0].reset();
        } catch (xhr: any) {
            const err: ApiResult | undefined = xhr?.responseJSON;
            if (err?.errors) {
                // tu si vieš vypísať chyby k poliam
                console.log(err.errors);
            }

            showMessage(err?.message ?? "Nastala chyba pri odosielaní.", "Chyba!");

            // reset Turnstile aj pri chybe (token už môže byť “spotrebovaný”)
            const w: any = window as any;
            if (w.turnstile && typeof w.turnstile.reset === "function") {
                w.turnstile.reset();
            }
        }
    });

});

